<script setup>
import { useDetectDevice } from '@/composables/device'
import { useWebSiteStore } from '@/stores/web-site.store'

import MyReportsView from '@/components/accounting/MyReportsView.vue'
import ReportsGrid from '@/components/accounting/ReportsGrid.vue'
import ReportsView from '@/components/accounting/ReportsView.vue'

const { isMobile } = useDetectDevice()
const webSiteStore = useWebSiteStore()
</script>
<template>
  <reports-view v-if="webSiteStore.can(webSiteStore.permissionFlagEnum.REPORTS) && isMobile" />
  <reports-grid v-else-if="webSiteStore.can(webSiteStore.permissionFlagEnum.REPORTS)" />
  <my-reports-view v-else />
</template>
